import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  return <AnimatePresence data-id="element-135">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8" data-id="element-136">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-137" />

          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.98
      }} transition={{
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} role="dialog" aria-modal="true" aria-label={title} className="relative w-full max-w-2xl max-h-[80vh] bg-avm-bgAlt border border-avm-border overflow-hidden flex flex-col z-10" data-id="element-138">
            <div className="flex items-center justify-between px-8 py-6 border-b border-avm-border shrink-0" data-id="element-139">
              <h2 className="font-serif text-2xl text-avm-text" data-id="element-140">{title}</h2>
              <button onClick={onClose} className="text-avm-textMuted hover:text-avm-text transition-colors p-1" aria-label="Close" data-id="element-141">
                <XIcon className="w-5 h-5" data-id="element-142" />
              </button>
            </div>

            <div className="overflow-y-auto px-8 py-8 text-avm-textMuted font-light leading-relaxed text-sm space-y-6" data-id="element-143">
              {children}
            </div>

            <div className="px-8 py-5 border-t border-avm-border shrink-0" data-id="element-144">
              <button onClick={onClose} className="text-sm font-medium text-avm-accent hover:text-avm-text transition-colors tracking-wide" data-id="element-145">
                Close
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}